const continuousTrackingDistanceMeters = 500;
const assumedTravelSpeedMetersPerSecond = 30;
const minimumSampleDelayMs = 15_000;
const maximumSampleDelayMs = 120_000;

export class GpsTriggerSamplingPolicy {
    nextSampleDelayMs(distanceMeters: number, accuracyMeters: number): number | undefined {
        if (!Number.isFinite(distanceMeters)) {
            return maximumSampleDelayMs;
        }

        const accuracy = Number.isFinite(accuracyMeters) ? Math.max(0, accuracyMeters) : 0;
        const effectiveDistance = Math.max(0, distanceMeters - accuracy);
        if (effectiveDistance <= continuousTrackingDistanceMeters) {
            return undefined;
        }

        const remainingDistance = effectiveDistance - continuousTrackingDistanceMeters;
        const calculatedDelayMs = Math.floor(remainingDistance / assumedTravelSpeedMetersPerSecond * 1_000);
        return Math.max(minimumSampleDelayMs, Math.min(maximumSampleDelayMs, calculatedDelayMs));
    }
}
